import { render } from "./rc-button.vue?vue&type=template&id=003bce28&scoped=true"
import script from "./rc-button.vue?vue&type=script&lang=js"
export * from "./rc-button.vue?vue&type=script&lang=js"

import "./rc-button.vue?vue&type=style&index=0&id=003bce28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003bce28"]])

export default __exports__